declare const __BUILD_HASH__: string;

const CACHE_KEY = 'app-build-hash';
const STORE_KEYS = ['claim-store', 'ui-store'];

/**
 * Clears persisted Zustand stores when a new build is detected.
 * Each Vite build generates a unique hash — if the stored hash
 * doesn't match, the localStorage entries for Zustand stores are
 * removed so stale data never rehydrates into a newer version.
 */
export function invalidateCacheIfNewBuild(): void {
  const storedHash = localStorage.getItem(CACHE_KEY);

  if (storedHash === __BUILD_HASH__) {
    return;
  }

  STORE_KEYS.forEach((key) => localStorage.removeItem(key));
  localStorage.setItem(CACHE_KEY, __BUILD_HASH__);

  console.info('[Claims Portal] Cache invalidated — new build detected');
}
